import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../auth/AuthProvider';
import { listMessages } from './client';
import { keys } from './keys';

/**
 * Fetch one workstream's persisted transcript (Drop 7 / S05, ADR-0047) — the
 * source that hydrates the client-held chat when an existing workstream is
 * reopened (`GET /workstreams/{id}/messages`). Keyed by
 * `keys.workstream.messages(workstreamId)`, `enabled` only for a real
 * workstream id (a fresh pre-create draft has none, and starts empty).
 *
 * Secondary/dependent data (R10) — plain `useQuery`, not the route's suspense
 * data. Honours the shared QueryClient defaults; errors route to `reportError`
 * via the shared `QueryCache.onError` sink.
 */
export function useMessages(workstreamId: string | null) {
  const { getAccessToken } = useAuth();
  return useQuery({
    queryKey: keys.workstream.messages(workstreamId ?? ''),
    queryFn: ({ signal }) => listMessages(workstreamId as string, { getAccessToken, signal }),
    enabled: workstreamId !== null,
  });
}
